/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Fail_BudgetInputs */

const en_import_fail_budget = /** @type {(inputs: Import_Fail_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly AI budget reached`)
};

const de_import_fail_budget = /** @type {(inputs: Import_Fail_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatliches KI-Budget erreicht`)
};

/**
* | output |
* | --- |
* | "Monthly AI budget reached" |
*
* @param {Import_Fail_BudgetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_fail_budget = /** @type {((inputs?: Import_Fail_BudgetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Fail_BudgetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_fail_budget(inputs)
	return en_import_fail_budget(inputs)
});